import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MinistryApiService } from '@core/api/services/ministry-api.service';
import {
  MinistryDto,
  CreateMinistryDto,
  UpdateMinistryDto,
  UpdateMinistrySortOrderDto,
} from '@core/api/generated/api-client';

export { MinistryDto, CreateMinistryDto, UpdateMinistryDto };

@Injectable({ providedIn: 'root' })
export class MinistryManagementService {
  constructor(private readonly api: MinistryApiService) {}

  getAll(): Observable<MinistryDto[]> {
    return this.api.getAll();
  }

  getById(id: number): Observable<MinistryDto> {
    return this.api.getById(id);
  }

  create(dto: CreateMinistryDto): Observable<MinistryDto> {
    return this.api.create(dto);
  }

  update(id: number, dto: UpdateMinistryDto): Observable<void> {
    return this.api.update(id, dto);
  }

  delete(id: number): Observable<void> {
    return this.api.delete(id);
  }

  updateSortOrder(id: number, sortOrder: number): Observable<void> {
    return this.api.updateSortOrder(id, UpdateMinistrySortOrderDto.fromJS({ sortOrder }));
  }
}
